export const EXPERIMENTS = {
    CHECKOUT_FLOW: 'CheckoutForm',
    DASHBOARD_BANNER: 'DashboardSubscribeBanner',
};
